import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  list: [],
  pageInfo: {},
  pagingCondition: {
    page: 1,
    limit: 10
  },
  nextId: null,
  detail: {}
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
